<div class="basepadding">


  <ion-grid>


    <ion-row class="">

      <ion-col size="12" class="bottomspace">

        <div class="row-layout">

          <div class="text-left status-badges">
            <!-- Abgeschlossen Badge -->
            <ion-badge *ngIf="order?.state === 1" color="warning" class="status-badge">
              <ion-icon name="lock-closed-outline"></ion-icon>
              Abgeschlossen
            </ion-badge>

            <!-- Änderungen Badge -->
            <ion-badge *ngIf="hasUnsavedChanges" color="danger" class="status-badge">
              <ion-icon name="alert-circle-outline"></ion-icon>
              Ungespeicherte Änderungen
            </ion-badge>

            <!-- Mini-Cart Summary -->
            <div class="mini-cart" *ngIf="cartItemCount > 0">
              <ion-icon name="cart-outline" class="cart-icon"></ion-icon>
              <span class="cart-count">{{ cartItemCount }} Stk.</span>
              <span class="cart-total">{{ cartTotal | number:'1.2-2' }} €</span>
            </div>
          </div>

          <div class="button-group">
            <!-- Standard actions: visible when user is owner and order.state is 0/null/undefined OR user is admin and order.state is 1 -->
            <ng-container *ngIf="showStandardActions()">
              <ion-button class="sidemargin" (click)="resetAndExit()" color="danger" fill="outline">
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
              <ion-button class="sidemargin" (click)="justSave()" color="confirm" fill="outline">
                <ion-icon name="save-outline"></ion-icon>
              </ion-button>
              <ion-button class="sidemargin" (click)="onExit()" color="confirm" fill="outline">
                <ion-icon name="folder-outline"></ion-icon>
              </ion-button>
            </ng-container>

            <!-- Force exit: visible when user is not owner and order.state is 0/null/undefined OR user is owner and order.state is 1 -->
            <ion-button *ngIf="showForceExit()" class="sidemargin" (click)="forceExit()" color="danger" fill="outline">
              <ion-icon name="log-out-outline"></ion-icon>
            </ion-button>

            <!-- Lokale Revisionen -->
            <ion-button class="sidemargin" (click)="showRevisions()" fill="outline" color="medium" title="Lokale Revisionen">
              <ion-icon name="time-outline"></ion-icon>
            </ion-button>

            <!-- JSON Export -->
            <ion-button class="sidemargin" (click)="exportOrderJson()" fill="outline" color="medium" title="Als JSON exportieren">
              <ion-icon name="download-outline"></ion-icon>
            </ion-button>

          </div>
        </div>

      </ion-col>
    </ion-row>


    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title-stack">
                <!-- Titel: editierbar oder nur Anzeige -->
                <div class="order-title editable-field" *ngIf="showStandardActions() && order">
                  <ion-input
                    [(ngModel)]="order.orderTitle"
                    (ionBlur)="onOrderPropertyChange('orderTitle', order.orderTitle)"
                    placeholder="Titel eingeben"
                    class="editable-input">
                  </ion-input>
                </div>
                <div class="order-title" *ngIf="!showStandardActions()">{{ order?.orderTitle }}</div>

                <!-- Order-Nummer darunter -->
                <div class="order-number-label" *ngIf="order?.orderNumber">Order {{ order?.orderNumber }}</div>
              </div>
              <div class="order-actions"></div>
            </div>
          </div>
        </div>



      </ion-col>
    </ion-row>

    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Kunde</div>
              <div class="order-actions">
                <!-- Button 1: Kunde wählen -->
                <ng-container *ngIf="!order?.customerBase">
                  <ion-searchbar
                    placeholder="Kunde suchen…"
                    [ngModel]="customerSearchTerm"
                    (ionInput)="onCustomerSearchChange($event)">
                  </ion-searchbar>

                  <ion-button (click)="chooseLexwareContact()" color="primary" fill="outline">
                    Kunde wählen
                  </ion-button>
                </ng-container>

                <!-- Button 2: Adresse bearbeiten
                <ng-container *ngIf="order?.customerBase">
                  <ion-button (click)="changeAddress()" color="primary" fill="outline">
                    Adresse bearbeiten
                  </ion-button>
                </ng-container>
-->

                <!-- Button 3: Kunde löschen -->
                <ng-container *ngIf="order?.customerBase">
                  <ion-button (click)="resetContact()" color="danger" fill="outline">
                    Kunden entfernen
                  </ion-button>
                </ng-container>

              </div>
            </div>

            <ng-container *ngIf="!order?.customerBase">
              <ion-list *ngIf="customerSearchTerm && lexwareContactsFiltered?.length">
                <ion-item
                  button
                  detail="false"
                  *ngFor="let c of lexwareContactsFiltered; trackBy: trackByCustomerId"
                  (click)="selectCustomerInline(c)">
                  <ion-label>
                    <div class="cardtitle">{{ c?.companyName || (c?.contactPerson?.firstName + ' ' + c?.contactPerson?.lastName) }}</div>
                    <div class="sizes" *ngIf="c?.address?.street">{{ c.address.street }} {{ c.address.supplement ? c.address.supplement : '' }}</div>
                    <div class="sizes" *ngIf="c?.address?.zip || c?.address?.city">{{ c.address.zip }} {{ c.address.city }}</div>
                    <div class="sizes" *ngIf="c?.email">{{ c.email }}</div>
                  </ion-label>
                  <ion-icon name="checkmark-outline" slot="end"></ion-icon>
                </ion-item>
              </ion-list>
            </ng-container>

            <!-- Adressen -->
            <div class="orderContent">
              <div *ngIf="order?.customerAddress" class="addr-grid">

                <!-- Rechnungsadresse -->
                <div class="addr-block">
                  <div class="addr-block-title">Rechnungsadresse</div>
                  <div class="addr-field">
                    <span class="addr-label">Name</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.name"
                      (ionBlur)="onBillingAddressChange('name', order!.customerAddress!.name)"
                      [readonly]="!showStandardActions()" placeholder="Name">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Zusatz</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.supplement"
                      (ionBlur)="onBillingAddressChange('supplement', order!.customerAddress!.supplement)"
                      [readonly]="!showStandardActions()" placeholder="Zusatz">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Straße</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.street"
                      (ionBlur)="onBillingAddressChange('street', order!.customerAddress!.street)"
                      [readonly]="!showStandardActions()" placeholder="Straße">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Stadt</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.city"
                      (ionBlur)="onBillingAddressChange('city', order!.customerAddress!.city)"
                      [readonly]="!showStandardActions()" placeholder="Stadt">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">PLZ</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.zip"
                      (ionBlur)="onBillingAddressChange('zip', order!.customerAddress!.zip)"
                      [readonly]="!showStandardActions()" placeholder="PLZ">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Ländercode</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerAddress!.countryCode"
                      (ionBlur)="onBillingAddressChange('countryCode', order!.customerAddress!.countryCode)"
                      [readonly]="!showStandardActions()" placeholder="Ländercode">
                    </ion-input>
                  </div>
                </div>

                <!-- Lieferadresse -->
                <div class="addr-block" *ngIf="order?.customerBase?.delivery">
                  <div class="addr-block-title">Lieferadresse</div>
                  <div class="addr-field">
                    <span class="addr-label">Firmenname</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerBase!.delivery!.companyName"
                      (ionBlur)="onDeliveryAddressChange('companyName', order!.customerBase!.delivery!.companyName)"
                      [readonly]="!showStandardActions()" placeholder="Firmenname">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Zusatz</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerBase!.delivery!.supplement"
                      (ionBlur)="onDeliveryAddressChange('supplement', order!.customerBase!.delivery!.supplement)"
                      [readonly]="!showStandardActions()" placeholder="Zusatz">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Straße</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerBase!.delivery!.street"
                      (ionBlur)="onDeliveryAddressChange('street', order!.customerBase!.delivery!.street)"
                      [readonly]="!showStandardActions()" placeholder="Straße">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">Stadt</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerBase!.delivery!.city"
                      (ionBlur)="onDeliveryAddressChange('city', order!.customerBase!.delivery!.city)"
                      [readonly]="!showStandardActions()" placeholder="Stadt">
                    </ion-input>
                  </div>
                  <div class="addr-field">
                    <span class="addr-label">PLZ</span>
                    <ion-input class="addr-input"
                      [(ngModel)]="order!.customerBase!.delivery!.zip"
                      (ionBlur)="onDeliveryAddressChange('zip', order!.customerBase!.delivery!.zip)"
                      [readonly]="!showStandardActions()" placeholder="PLZ">
                    </ion-input>
                  </div>
                </div>

              </div>

              <div class="no-address" *ngIf="!order?.customerAddress">
                Kein Kunde ausgewählt
              </div>
            </div>
          </div>
        </div>



      </ion-col>
    </ion-row>

    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Produkte</div>
              <div class="order-actions">

              </div>
            </div>

            <!-- Kundenadresse -->
            <div class="orderContent">
              <!-- Produktsuche nur bei bearbeitbarem Auftrag: bei abgeschlossenem
                   Auftrag gibt es nichts hinzuzufügen, also auch nichts zu suchen. -->
              <ng-container *ngIf="showStandardActions()">
                <div class="product-search-row">
                  <ion-searchbar
                    placeholder="Produkt suchen…"
                    [ngModel]="productSearchTerm"
                    (ionInput)="onProductSearchChange($event)">
                  </ion-searchbar>

                  <div class="season-filter">
                    <ion-button fill="clear" class="filter-btn" aria-label="Saison Filter">
                      <ion-icon name="filter-outline"></ion-icon>
                    </ion-button>
                    <ion-select
                      class="season-select"
                      [(ngModel)]="selectedSeason"
                      (ionChange)="changeSelectedSeason(selectedSeason)"
                      placeholder="Saison">
                      <ion-select-option value="all">Alle</ion-select-option>
                      <ion-select-option *ngFor="let season of availableSeasons" [value]="season">{{ season }}</ion-select-option>
                    </ion-select>
                  </div>
                </div>
                <ion-list *ngIf="productListFiltered?.length">
                  <ion-item
                    button
                    detail="false"
                    *ngFor="let p of productListFiltered; trackBy: trackByProductSearchId"
                    (click)="openProductFromSearch(p)">
                    <ion-label>
                      <div class="cardtitle">{{ p?.name }}</div>
                      <div class="sizes">{{ p?.season }} {{ p?.model }} – {{ p?.color }} <span class="faded">{{ p?.colorname }}</span></div>
                    </ion-label>
                    <ion-icon name="add-outline" slot="end"></ion-icon>
                  </ion-item>
                </ion-list>
              </ng-container>

              <app-order-overview></app-order-overview>


            </div>
          </div>
        </div>



      </ion-col>
    </ion-row>

    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Info</div>
            </div>

            <!-- Kundenadresse -->
            <div class="orderContent">
              <ion-item *ngIf="order">
                <ion-label position="stacked">Kunde Email:</ion-label>
                <ion-input
                  [(ngModel)]="order.customerEmail"
                  (ionBlur)="onOrderPropertyChange('customerEmail', order.customerEmail)"
                  placeholder="Email eingeben">
                </ion-input>
              </ion-item>

              <ion-item *ngIf="order?.customerEmail">
                <ion-text>Auftragsübersicht an Kunden senden ({{ order?.customerEmail }})</ion-text>
                <ion-button slot="end" (click)="sendconfirm(userdata.email, (order?.customerEmail || undefined))">Senden</ion-button>
              </ion-item>

              <ion-item *ngIf="order?.customerEmail == ''">
                <ion-text>Auftragsübersicht an Kunden senden</ion-text>
                <ion-button slot="end" disabled>Senden</ion-button>
              </ion-item>


              <ion-item>
                <ion-text>Auftragsübersicht an hinterlegte Email senden ({{userdata.email}})</ion-text>
                <ion-button slot="end" (click)="sendconfirm(userdata.email, undefined)">Senden</ion-button>
              </ion-item>
              @if (userdata.role == 'admin') {
              <ion-item>
                <ion-text>Auftragsübersicht an Admin senden (wolfgangbloemacher&#64;gmx.de)</ion-text>
                <ion-button slot="end" (click)="sendconfirm('wolfgangbloemacher@gmx.de', undefined)">Senden</ion-button>
              </ion-item>
              }


            </div>
          </div>
        </div>



      </ion-col>
    </ion-row>


    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">

            <div class="order-header">
              <div class="order-title">Verwaltung</div>
            </div>

              <ion-item *ngIf="order && (order.updatedBy || order.updatedAt)">
                <ion-label>
                  <p class="ion-text-wrap" style="color: #666; font-size: 13px;">
                    <ion-icon name="time-outline" style="vertical-align: middle; margin-right: 4px;"></ion-icon>
                    <strong>Zuletzt geändert:</strong>
                    {{ order.updatedAt | date:'dd.MM.yyyy HH:mm' }}
                    <ng-container *ngIf="order.updatedBy">
                      von {{ getUpdatedByName(order.updatedBy) }}
                    </ng-container>
                  </p>
                </ion-label>
                <ion-button slot="end" fill="outline" size="small" (click)="openOrderHistory()">
                  <ion-icon name="list-outline" slot="start"></ion-icon>
                  Historie
                </ion-button>
              </ion-item>

              <ion-item *ngIf="order">
                <ion-label position="stacked">Lieferzeitraum:</ion-label>
                <ion-input
                  [(ngModel)]="order.deliveryNote"
                  (ionBlur)="onOrderPropertyChange('deliveryNote', order.deliveryNote)"
                  [readonly]="!showStandardActions()"
                  placeholder="Lieferzeitraum eingeben">
                </ion-input>
              </ion-item>

              <!-- Order Comments -->
              <div *ngIf="order" style="margin-top: 16px;">
                <app-order-comments
                  [orderId]="order.orderId"
                  [comments]="order.comments || []"
                  [orderState]="order.state"
                  [orderSynced]="order.sync !== false">
                </app-order-comments>
              </div>


    @if (userdata.role == 'admin') {


            <div class="order-header">
              <div class="order-title ptop">Admin</div>
            </div>


            <!-- Kundenadresse -->
            <div class="orderContent">

              <ion-item *ngIf="order">
                <ion-label position="stacked">Private Notiz</ion-label>
                <ion-input
                  [(ngModel)]="order.note"
                  (ionBlur)="onOrderPropertyChange('note', order.note)"
                  [readonly]="!showStandardActions()"
                  placeholder="Notiz eingeben">
                </ion-input>
              </ion-item>

              <ion-item *ngIf="order">
                <ion-label position="stacked">Firmeninfo:</ion-label>
                <ion-input
                  [(ngModel)]="order.companyName"
                  (ionBlur)="onOrderPropertyChange('companyName', order.companyName)"
                  [readonly]="!showStandardActions()"
                  placeholder="Firmeninfo eingeben">
                </ion-input>
              </ion-item>


              <ion-item *ngIf="order">
                <ion-label position="stacked">Agenturinfo:</ion-label>
                <ion-input
                  [(ngModel)]="order.agentNote"
                  (ionBlur)="onOrderPropertyChange('agentNote', order.agentNote)"
                  [readonly]="!showStandardActions()"
                  placeholder="Agenturinfo eingeben">
                </ion-input>
              </ion-item>


              <ion-item *ngIf="order">
                <ion-label position="stacked">Lieferreferenz (für Italien):</ion-label>
                <ion-input
                  [(ngModel)]="order.deliveryRef"
                  (ionBlur)="onOrderPropertyChange('deliveryRef', order.deliveryRef)"
                  [readonly]="!showStandardActions()"
                  placeholder="Lieferreferenz eingeben">
                </ion-input>
              </ion-item>

              <ion-item>
                <ion-text>PDF für Italien an mich senden</ion-text>
                <ion-button slot="end" (click)="sendwhole()">Senden</ion-button>
              </ion-item>


            </div>

}




          </div>
        </div>



      </ion-col>
    </ion-row>

    @if (userdata.role == 'admin') {
    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Lexware</div>
              <div class="order-actions">

              </div>
            </div>

            <!-- Kundenadresse -->
            <div class="orderContent">


              @if (order?.orderNumber === "asd") {
              <ion-item>
                <ion-label>Lieferschein</ion-label>
                <ion-button slot="end" (click)="createDeliveryNote(this.order)">Erstellen</ion-button>
              </ion-item>
              }

              <ion-item>
                <ion-label>Rechnung</ion-label>
                <ion-button slot="end" (click)="createInvoice(this.order)">Erstellen</ion-button>
              </ion-item>

              @if (userdata.role == 'admin') {
              <ion-item>
                <ion-label>Lieferungen verwalten</ion-label>
                <ion-button slot="end" color="tertiary" (click)="openDeliveryManager()">Lieferungen</ion-button>
              </ion-item>
              }

            </div>
          </div>
        </div>

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Karma B2B</div>
            </div>
            <div class="orderContent">
              <ion-item>
                <ion-label>Kürzel für Warenkorb</ion-label>
                <ion-select [(ngModel)]="karmaKuerzelMode" interface="popover" slot="end">
                  <ion-select-option value="user">
                    User ({{ userKuerzel || 'kein Kürzel' }})
                  </ion-select-option>
                  <ion-select-option value="customer">
                    Kunde ({{ order?.customerBase?.kuerzel || 'kein Kürzel' }})
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item>
                <ion-label>Zahlungsart</ion-label>
                <ion-select [(ngModel)]="karmaPaymentId" interface="popover" slot="end">
                  @for (opt of karmaPaymentOptions; track opt.id) {
                    <ion-select-option [value]="opt.id">{{ opt.label }}</ion-select-option>
                  }
                </ion-select>
              </ion-item>
              <ion-item>
                <ion-label position="stacked">Lieferdatum</ion-label>
                <ion-input [(ngModel)]="karmaDeliveryDate" placeholder="TT.MM.JJJJ" type="text"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="stacked">E-Mail</ion-label>
                <ion-input [(ngModel)]="karmaEmail" type="email" inputmode="email"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="stacked">Telefon</ion-label>
                <ion-input [(ngModel)]="karmaPhone" type="tel" inputmode="tel"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="stacked">Notiz (nach Kürzel)</ion-label>
                <ion-input [(ngModel)]="karmaNote" type="text" placeholder="z.B. Rechnung bitte kopieren"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label>
                  <p>Warenkorb bei Karma B2B anlegen</p>
                  @if (order?.karmaCartId) {
                    <p class="transcend">Zuletzt: {{ order?.karmaCartId }}</p>
                  }
                  @if (karmaCartRef) {
                    <p class="transcend">
                      Warenkorb: {{ karmaCartRef.label }}
                      @if (karmaCartRef.url) {
                        — <a [href]="karmaCartRef.url" target="_blank">bei Karma öffnen</a>
                      }
                    </p>
                  }
                </ion-label>
                <ion-button slot="end" color="success" [disabled]="karmaSending" (click)="sendToKarma()">
                  @if (karmaSending) {
                    <ion-spinner name="crescent" slot="start"></ion-spinner>
                  }
                  Übertragen
                </ion-button>
              </ion-item>
            </div>
          </div>
        </div>

      </ion-col>
    </ion-row>
}

    <ion-row class="">
      <ion-col size="12" class="">

        <div class="order-card">
          <div class="cardcontent">
            <div class="order-header">
              <div class="order-title">Aktion</div>
              <div class="order-actions">

              </div>
            </div>

            <!-- Kundenadresse -->
            <div class="orderContent">

              <ion-item *ngIf="canFinishOrder()">
                <ion-label>Auftrag abschließen - Finalisierung und Übergabe des Auftrags</ion-label>
                <ion-button slot="end" color="warning" (click)="finishOrder()">Auftag abschließen</ion-button>
              </ion-item>

              <ion-item *ngIf="isAdmin() && isOrderClosed()">
                <ion-label>Auftrag wieder öffnen - Agenten können den Auftrag wieder bearbeiten</ion-label>
                <ion-button slot="end" color="primary" (click)="reopenOrder()">Wieder öffnen</ion-button>
              </ion-item>

              <ion-item *ngIf="isAdmin()">
                <ion-label>Besitzer wechseln - Auftrag an einen anderen Benutzer übertragen</ion-label>
                <ion-button slot="end" color="primary" fill="outline" (click)="changeOrderOwner()">Besitzer wechseln</ion-button>
              </ion-item>

              <ion-item *ngIf="isOrderOwner() && canFinishOrder()">
                <ion-label>Auftrag verbergen - Fehlerhafte oder nicht mehr benötigte Aufträge </ion-label>
                <ion-button slot="end" color="danger"  (click)="archiveOrder()">Auftrag dauerhaft verbergen</ion-button>
              </ion-item>

              <ion-item>
                <ion-label>Auftrag als JSON herunterladen - Sicherung des aktuellen Auftragsstands</ion-label>
                <ion-button slot="end" fill="outline" (click)="downloadOrderAsJson()">Als JSON herunterladen</ion-button>
              </ion-item>

            </div>
          </div>
        </div>



      </ion-col>
    </ion-row>



  </ion-grid>

</div>

